export default (flag, cls) => {
	return flag ? '' :  ' ' + cls;
};
